<template>
  <div class="zzl-images-page">
    <div class="zzl-images-toolbar">
      <Input
        v-model="search"
        placeholder="搜索图片名称"
        style="width: 300px"
        @keyup.enter="fetchImages"
      />
      <Button icon="ios-search" @click="fetchImages" type="primary">搜索</Button>
    </div>
    <div v-if="loading" class="zzl-images-loading">
      <Icon type="ios-loading" size="28" class="ivu-load-loop"></Icon>
      <span style="margin-left:10px;">加载中...</span>
    </div>
    <div v-else class="zzl-images-body">
      <div v-if="images.length === 0" class="zzl-images-empty">
        暂无图片
      </div>
      <template v-else>
        <div class="zzl-images-scroll">
          <div class="zzl-images-grid">
            <div
              v-for="(img, idx) in images"
              :key="img.url + idx"
              class="zzl-images-card"
            >
              <div class="zzl-images-thumb" @click="openPreview(img)">
                <img
                  :src="img.url"
                  :alt="img.name"
                  @error="onImgError($event)"
                />
              </div>
              <div class="zzl-images-name" :title="img.name">{{ img.name }}</div>
              <div v-if="img.type" class="zzl-images-type">{{ img.type }}</div>
              <Button
                type="text"
                size="small"
                icon="ios-download-outline"
                class="zzl-images-download"
                @click.stop="downloadImage(img)"
              >下载</Button>
            </div>
          </div>
        </div>
        <Page
          :total="total"
          :page-size="limit"
          :current="page"
          show-total
          :show-elevator="true"
          @on-change="handlePage"
          class="zzl-images-page-bar"
        />
      </template>
    </div>

    <Modal
      v-model="previewVisible"
      title="图片预览"
      :width="720"
      footer-hide
      :transfer="false"
    >
      <div v-if="previewImg" class="zzl-images-preview-body">
        <img
          :src="previewImg.url"
          :alt="previewImg.name"
          class="zzl-images-preview-img"
        />
        <div class="zzl-images-preview-actions">
          <Button type="primary" icon="ios-download-outline" @click="downloadImage(previewImg)">
            下载
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      images: [],
      total: 0,
      limit: 50,
      page: 1,
      loading: false,
      previewVisible: false,
      previewImg: null,
    };
  },
  methods: {
    openPreview(img) {
      this.previewImg = img;
      this.previewVisible = true;
    },
    async downloadImage(img) {
      if (!img || !img.url) return;
      const name = (img.name && String(img.name).trim()) || "image";
      try {
        const res = await fetch(img.url, { mode: "cors" });
        if (!res.ok) throw new Error("fetch failed");
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        const a = document.createElement("a");
        a.href = img.url;
        a.download = name;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    fetchImages() {
      this.loading = true;
      this.$api
        .get("/logined_zzl/raw_images", {
          params: {
            limit: this.limit,
            page: this.page,
            search: this.search,
          },
        })
        .then(res => {
          const data = res.data?.data || {};
          this.images = data.images || [];
          this.total = data.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePage(page) {
      this.page = page;
      this.fetchImages();
    },
    onImgError(ev) {
      ev.target.src =
        "https://via.placeholder.com/90x90?text=No+Image";
    },
  },
  mounted() {
    this.fetchImages();
  },
  watch: {
    // If user clears the search, auto search
    search(val) {
      if (val === "") {
        this.page = 1;
        this.fetchImages();
      }
    }
  }
};
</script>

<style scoped lang="less">
.zzl-images-page {
  padding: 16px 24px 20px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 35%, #fff 100%);
}

.zzl-images-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-shrink: 0;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.zzl-images-loading {
  padding: 48px 0;
  text-align: center;
}

.zzl-images-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.zzl-images-empty {
  padding: 60px 0;
  text-align: center;
  color: #888;
}

/* 列表区占满剩余高度，底部分页始终可见 */
.zzl-images-scroll {
  flex: 1;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 12px;
  padding-right: 4px;
}

.zzl-images-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 16px;
}

.zzl-images-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 8px 8px;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.zzl-images-card:hover {
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.zzl-images-thumb {
  cursor: pointer;
  margin-bottom: 6px;
  img {
    display: block;
    max-width: 90px;
    max-height: 90px;
    border-radius: 3px;
    background: #fff;
  }
}

.zzl-images-name {
  text-align: center;
  font-size: 13px;
  color: #444;
  word-break: break-all;
  max-width: 95px;
  max-height: 38px;
  overflow: hidden;
}

.zzl-images-type {
  font-size: 11px;
  color: #aaa;
  margin-top: 2px;
}

.zzl-images-download {
  margin-top: 4px;
  padding: 0 4px;
  height: auto;
  line-height: 1.4;
}

.zzl-images-page-bar {
  text-align: center;
  flex-shrink: 0;
}

.zzl-images-preview-body {
  text-align: center;
}

.zzl-images-preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  vertical-align: middle;
}

.zzl-images-preview-actions {
  margin-top: 16px;
}
</style>
